import { css } from '@emotion/core';
/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import Button from '@atlaskit/button/custom-theme-button';
import { gridSize } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const EmptyStateWrapper = styled.div({
  textAlign: 'center',
  paddingBottom: `${gridSize() * 6}px`,
});

const CommonImageStyle = css({
  height: `${gridSize() * 40}px`,
  objectFit: 'contain',
  marginBottom: `${gridSize() * 2}px`,
});

export const LinkOptionsImage = styled.img(CommonImageStyle, {
  marginLeft: `${gridSize() * -8.5}px`,
});

export const IssuesListImage = styled.img(CommonImageStyle, {
  marginLeft: `${gridSize() * -8}px`,
  marginRight: `${gridSize() * -8}px`,
});

export const Description = styled.div({
  margin: `${gridSize() * 1.5}px auto 0 auto`,
  maxWidth: `${gridSize() * 80}px`,
  wordWrap: 'break-word',
});

export const HighlightItems = styled.div({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'space-evenly',
  margin: `${gridSize() * 3}px auto ${gridSize() * 4}px`,
  maxWidth: `${gridSize() * 170}px`,
});

export const HighlightItem = styled.div({
  display: 'flex',
  flexDirection: 'column',
  margin: `0 ${gridSize() * 2}px ${gridSize() * 2}px`,
  width: `${gridSize() * 40}px`,
});

export const ManageProjectsButton = styled(Button)({
  fontWeight: token('font.weight.regular'),
  height: `${gridSize()}px`,
  padding: 0,
  verticalAlign: 'baseline',
  '& span': {
    margin: 0,
  },
});
